import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import Privacy from './pages/privacy';
import Start from './pages/start';
import ResetPassword from './pages/reset-password';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/">
          <Route index element={<Start />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="legal/">
            <Route path="privacy" element={<Privacy />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
